interface LabelCase {
  label: string
}


interface VisibleStateModel {
  PRIVATE: string
  PUBLIC: string
}

export const VISIBLE_STATE: VisibleStateModel = {
  PRIVATE: "Private",
  PUBLIC: "Public"
}

export const VISIBLE_STATE_CASES: LabelCase[] = [
  { label: VISIBLE_STATE.PRIVATE },
  { label: VISIBLE_STATE.PUBLIC }
]


interface MemberStatusModel {
  ACTIVE: string
  INACTIVE: string
  SUSPENDED: string
}

export const MEMBER_STATUS: MemberStatusModel = {
  ACTIVE: "Active",
  INACTIVE: "Inactive",
  SUSPENDED: "Suspended"
}


interface MemberTypeModel {
  MEMBER: string
  PROSPECT: string
  DRAFT: string
}

export const MEMBER_TYPE: MemberTypeModel = {
  MEMBER: "Member",
  PROSPECT: "Prospect",
  DRAFT: "Draft"
}

export const MEMBER_TYPE_CASES: LabelCase[] = [
  { label: MEMBER_TYPE.MEMBER },
  { label: MEMBER_TYPE.PROSPECT },
  { label: MEMBER_TYPE.DRAFT }
]


interface MemberCategoryModel {
  COMP_INVESTOR: string
  COMP_MEMBER: string
  FOUNDING_OVERSEAS_MEMBER: string
  SPONSORED_MEMBER: string
  INVESTOR_MEMBER: string
  FULL_MEMBER: string
  OVERSEAS_MEMBER: string
  PAUSED_MEMBER: string
  DISCOUNTED_MEMBER: string
  NON_VAT_OVERSEAS_MEMBER: string
  OUT_OF_TOWN_MEMBER: string
  FAMILY_MEMBER: string
  SPOUSAL_MEMBER: string
  PRO_RATA_MEMBER: string
  BI_ANNUAL_MEMBER: string
  QUARTERLY_MEMBER: string
  CORPORATE_MEMBER: string
  FOUNDER_MEMBER: string
  FULL_MEMBERSHIP_NO_VAT: string
  HONORARY_MEMBERSHIP: string
  LIFETIME_MEMBERSHIP: string
  CROSS_BENEFIT_MEMBER: string
  CHARTER_MEMBER: string
  CHARTER_MEMBER_NO_VAT: string
}

export const MEMBER_CATEGORY: MemberCategoryModel = {
  COMP_INVESTOR: "Comp Investor",
  COMP_MEMBER: "Comp Member",
  FOUNDING_OVERSEAS_MEMBER: "Founding Overseas Member",
  SPONSORED_MEMBER: "Sponsored Member",
  INVESTOR_MEMBER: "Investor Member",
  FULL_MEMBER: "Full Member",
  OVERSEAS_MEMBER: "Overseas Member",
  PAUSED_MEMBER: "Paused Member",
  DISCOUNTED_MEMBER: "Discounted Member",
  NON_VAT_OVERSEAS_MEMBER: "Non-VAT Overseas Member",
  OUT_OF_TOWN_MEMBER: "Out-of-Town Member",
  FAMILY_MEMBER: "Family Member",
  SPOUSAL_MEMBER: "Spousal Member",
  PRO_RATA_MEMBER: "Pro-rata Member",
  BI_ANNUAL_MEMBER: "Bi-Annual Member",
  QUARTERLY_MEMBER: "Quarterly Member",
  CORPORATE_MEMBER: "Corporate Member",
  FOUNDER_MEMBER: "Founder Member",
  FULL_MEMBERSHIP_NO_VAT: "Full Membership - No VAT",
  HONORARY_MEMBERSHIP: "Honorary Membership",
  LIFETIME_MEMBERSHIP: "Lifetime Membership",
  CROSS_BENEFIT_MEMBER: "Cross Benefit Member",
  CHARTER_MEMBER: "Charter Member",
  CHARTER_MEMBER_NO_VAT: "Charter Member-No VAT"
}

export const MEMBER_CATEGORY_CASES: LabelCase[] = [
  { label: MEMBER_CATEGORY.COMP_INVESTOR },
  { label: MEMBER_CATEGORY.COMP_MEMBER },
  { label: MEMBER_CATEGORY.FOUNDING_OVERSEAS_MEMBER },
  { label: MEMBER_CATEGORY.SPONSORED_MEMBER },
  { label: MEMBER_CATEGORY.INVESTOR_MEMBER },
  { label: MEMBER_CATEGORY.FULL_MEMBER },
  { label: MEMBER_CATEGORY.OVERSEAS_MEMBER },
  { label: MEMBER_CATEGORY.PAUSED_MEMBER },
  { label: MEMBER_CATEGORY.DISCOUNTED_MEMBER },
  { label: MEMBER_CATEGORY.NON_VAT_OVERSEAS_MEMBER },
  { label: MEMBER_CATEGORY.OUT_OF_TOWN_MEMBER },
  { label: MEMBER_CATEGORY.FAMILY_MEMBER },
  { label: MEMBER_CATEGORY.SPOUSAL_MEMBER },
  { label: MEMBER_CATEGORY.PRO_RATA_MEMBER },
  { label: MEMBER_CATEGORY.BI_ANNUAL_MEMBER },
  { label: MEMBER_CATEGORY.QUARTERLY_MEMBER },
  { label: MEMBER_CATEGORY.CORPORATE_MEMBER },
  { label: MEMBER_CATEGORY.FOUNDER_MEMBER },
  { label: MEMBER_CATEGORY.FULL_MEMBERSHIP_NO_VAT },
  { label: MEMBER_CATEGORY.HONORARY_MEMBERSHIP },
  { label: MEMBER_CATEGORY.LIFETIME_MEMBERSHIP },
  { label: MEMBER_CATEGORY.CROSS_BENEFIT_MEMBER },
  { label: MEMBER_CATEGORY.CHARTER_MEMBER },
  { label: MEMBER_CATEGORY.CHARTER_MEMBER_NO_VAT }
]


interface EventRegistrationStatusModel {
  OPEN: string
  CLOSE: string
  SCHEDULED: string
}

export const EVENT_REGISTRATION_STATUS: EventRegistrationStatusModel = {
  OPEN: "Open",
  CLOSE: "Close",
  SCHEDULED: "Scheduled"
}

export const EVENT_REGISTRATION_STATUS_CASES: LabelCase[] = [
  { label: EVENT_REGISTRATION_STATUS.OPEN },
  { label: EVENT_REGISTRATION_STATUS.CLOSE },
  { label: EVENT_REGISTRATION_STATUS.SCHEDULED }
]


interface ProductTypeModel {
  SUBSCRIPTION: string
}

export const PRODUCT_TYPE: ProductTypeModel = {
  SUBSCRIPTION: "subscription"
}

export const PRODUCT_TYPES_CASES: LabelCase[] = [
  { label: PRODUCT_TYPE.SUBSCRIPTION }
]
